// extracted by mini-css-extract-plugin
export var activityContainer = "_j6-0";
export var typingIndicatorContainer = "_j6-1";
export var typingIndicatorDot = "_j6-2";
export var wave = "_j6-3";